/**
 * @generated SignedSource<<6fc7a63bde99ce12cf83cf1f9ca7e303>>
 * @relayHash 76ef1fb1bc3eb5b6331e7ac4c7d92098
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 76ef1fb1bc3eb5b6331e7ac4c7d92098

import { ConcreteRequest } from 'relay-runtime';
export type AsyncRequestStatus = "APPROVED" | "REJECTED";
export type UpdateAppointmentAsyncRequestStatusInput = {
  asyncRequestStatus: AsyncRequestStatus;
  id: string;
};
export type useUpdateAppointmentAsyncRequestStatusMutation$variables = {
  input: UpdateAppointmentAsyncRequestStatusInput;
};
export type useUpdateAppointmentAsyncRequestStatusMutation$data = {
  readonly updateAppointmentAsyncRequestStatus: {
    readonly appointment: {
      readonly asyncRequestStatus: AsyncRequestStatus | null;
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly appointmentId?: number;
      readonly message?: string;
    }> | null;
  };
};
export type useUpdateAppointmentAsyncRequestStatusMutation = {
  response: useUpdateAppointmentAsyncRequestStatusMutation$data;
  variables: useUpdateAppointmentAsyncRequestStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Appointment",
  "kind": "LinkedField",
  "name": "appointment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "asyncRequestStatus",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = [
  (v3/*:: as any*/)
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*:: as any*/),
  "type": "ActionNotAllowedOnClosedOrCancelledAppointment",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentId",
      "storageKey": null
    },
    (v3/*:: as any*/)
  ],
  "type": "AppointmentNotFound",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v4/*:: as any*/),
  "type": "CannotUpdateAppointmentAsyncRequestStatusForNonAsyncChannel",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateAppointmentAsyncRequestStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAppointmentAsyncRequestStatusPayload",
        "kind": "LinkedField",
        "name": "updateAppointmentAsyncRequestStatus",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdateAppointmentAsyncRequestStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAppointmentAsyncRequestStatusPayload",
        "kind": "LinkedField",
        "name": "updateAppointmentAsyncRequestStatus",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "76ef1fb1bc3eb5b6331e7ac4c7d92098",
    "metadata": {},
    "name": "useUpdateAppointmentAsyncRequestStatusMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "486c26aafb49ce598fbd8eca49a9c045";

export default node;
